import {AppLayout} from "../layout/AppLayout.tsx";
import {IndexPage} from "../features/home/pages/IndexPage.tsx";
import {PrivacyPage} from "../features/home/pages/PrivacyPage.tsx";
import {TermsOfServicePage} from "../features/home/pages/TermsOfServicePage.tsx";

export const routesConfig = [{
    path: '/',
    element: <AppLayout/>,
    children: [{
        index: true,
        element: <IndexPage/>
    }, {
        path: 'privacy',
        element: <PrivacyPage
            application={{
                name: "Flexi Network",
                url: "flexi.network"
            }}/>
    }, {
        path: 'terms-of-service',
        element: <TermsOfServicePage
            application={{
                name: "Flexi Network",
                url: "https://www.flexi.network",
                email: "support@flexi.network"
            }}/>
    }]
}]